import CurrencyValueUIModel from './currency-value';

class CurrencyPerSegmentUIModel {
  constructor({
    currency = {},
    farelogixDesignator = null,
    farelogixPrice = false,
    redeemedCorporate = false,
    segmentCode = undefined,
  } = {}) {
    this.currency = new CurrencyValueUIModel(currency);
    this.farelogixDesignator = farelogixDesignator;
    this.farelogixPrice = farelogixPrice;
    this.redeemedCorporate = redeemedCorporate;
    this.segmentCode = segmentCode;
  }

  getSegmentCode() {
    return this.segmentCode;
  }

  toAPI() {
    return {
      'currency': this.currency ? this.currency.toAPI() : this.currency,
      'farelogixDesignator': this.farelogixDesignator,
      'farelogixPrice': this.farelogixPrice,
      'redeemedCorporate': this.redeemedCorporate,
      'segmentCode': this.segmentCode,
    };
  }
}

export default CurrencyPerSegmentUIModel;
